import { memo } from 'react';
import { Box, Hidden, Typography } from '@lingoda/ui';
import { getLessonSubtitle } from '../../helpers';

interface Props {
    lessonTitle: string;
    chapterName: string;
    moduleName: string;
    lessonLabel: string;
}

const ClassListItemInfoComponent = ({
    moduleName,
    chapterName,
    lessonTitle,
    lessonLabel,
}: Props) => {
    const subtitle = getLessonSubtitle(moduleName, chapterName, lessonLabel);

    return (
        <Box>
            <Hidden lgDown>
                <Box>
                    <Typography
                        variant="overline"
                        data-cy="classListItemInfo_subtitle"
                        htmlColor="text.secondary"
                    >
                        {subtitle}
                    </Typography>
                </Box>
                <Typography
                    variant="h6"
                    data-cy="classListItemInfo_lessonTitle"
                    htmlColor="text.primary"
                >
                    {lessonTitle}
                </Typography>
            </Hidden>
            <Hidden lgUp>
                <Box sx={{ mb: 0.5 }}>
                    <Typography
                        variant="h6"
                        data-cy="classListItemInfo_lessonTitle"
                        htmlColor="text.primary"
                    >
                        {lessonTitle}
                    </Typography>
                </Box>
                <Typography
                    variant="overline"
                    data-cy="classListItemInfo_subtitle"
                    htmlColor="text.secondary"
                >
                    {subtitle}
                </Typography>
            </Hidden>
        </Box>
    );
};

export const ClassListItemInfo = memo(ClassListItemInfoComponent);
